import $ from "jquery";
import bdjs from "@bd-core/bdjs";
import bdapi from "@bd-core/bd-api";
import CONFIG from "@bd-core/config";

export const SubscribeSessionPage = () => {
    const isSubscribeSession = $("#page-subscribe-session").length > 0;
    if (!isSubscribeSession) return false;

    bdjs.hideLoading();

    const init = () => {
        registerEvents();
        autoFillInput();
    };

    const registerEvents = () => {
        $(".js-open-form").on("click", openForm);
        $(".js-back").on("click", onBackToSelection);
        $(".js-add-member").on("click", addMember);
        $(document).on("click", ".js-remove-field", removeField);
        $(document).on("click", "#sendInvitations", submitInvitation);
        $(document).on("click", "#sendMatchmaking", submitMatchMaking);
        $(document).on("click", "#addMember", goToAddMember);
        $(document).on("input", "input", onInputField);
    };

    const autoFillInput = () => {
        if (CONFIG.isAuth) {
            $(".js-login[name=name]").val(CONFIG.user.nickname);
            $(".js-login[name=email]").val(CONFIG.user.email);
        }
    };

    const onBackToSelection = () => {
        const $description = $(".welcome__description");
        const $btnSubmit = $(".js-submit-btn");

        $description.removeClass("is-matchmaking");
        $btnSubmit.removeClass("is-matchmaking");
        $(".welcome").removeClass("is-login");
        $(".welcome__steps").show();
        $(".is-invitation").hide();
        $(".welcome__backhome").show();
    };

    let isLoading = false;
    const submitInvitation = async function (e) {
        e.preventDefault();
        if (isLoading) return false;

        const $btn = $("#sendInvitations");

        $btn.addClass("is-loading").prop("disabled", true);

        isLoading = true;

        const isEmail = (email) => {
            var re =
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; //eslint-disable-line
            return re.test(String(email).toLowerCase());
        };

        let formData = [];
        let isValid = true;
        let errMsg = "";
        const $fields = $(".invitations__fields:not(.to-be-cloned)");
        const initiator_name = String($(".js-login[name=name]").val()).trim();
        const initiator_email = String($(".js-login[name=email]").val()).trim();

        formData.push({
            name: initiator_name,
            email: initiator_email,
        });

        $fields.each((i, el) => {
            let name = String($(el).find(".name").val()).trim();
            let email = String($(el).find(".email").val()).trim();

            if (!name || name == "") {
                isValid = false;
                errMsg = "Name is required.";
                $(el).find(".name").trigger("focus");
            } else if (!isEmail(email)) {
                isValid = false;
                errMsg = "Invalid email address.";
                $(el).find(".email").trigger("focus");
            } else if (formData.some((x) => x.email == email)) {
                isValid = false;
                errMsg = "Duplicate email address.";
                $(el).find(".email").trigger("focus");
            }

            if (!isValid) {
                return false;
            }

            formData.push({ name, email });
        });

        if (!isValid) {
            $snackBar
                .addClass("is-active")
                .find(".snackbar__body")
                .html(errMsg);
            $btn.removeClass("is-loading");

            isLoading = false;

            return false;
        }

        if (!formData.length) {
            isLoading = false;
            $btn.removeClass("is-loading");
            return false;
        }

        const [res, err] = await bdjs.goAsync(
            bdapi.post("public/submit-invitation", {
                data: formData,
            }),
        );

        isLoading = false;
        const restData = res?.data || {};

        if (restData?.success) {
            const msg = restData?.data?.message;
            $snackBar.addClass("is-active").find(".snackbar__body").html(msg);

            $fields.find("input").prop("disabled", true);
            $btn.removeClass("is-loading").prop("disabled", true);
        }

        if (!restData?.success || err) {
            const errMsg =
                restData?.data?.message ||
                "Something went wrong. Please try again!";

            $snackBar
                .addClass("is-active")
                .find(".snackbar__body")
                .html(errMsg);
            $btn.removeClass("is-loading").prop("disabled", false);
        }
    };

    const submitMatchMaking = async function (e) {
        e.preventDefault();
        if (isLoading) return false;

        const $btn = $(e.currentTarget);
        const $name = $(".js-login[name=name]");
        const $email = $(".js-login[name=email]");

        $btn.addClass("is-loading").prop("disabled", true);

        isLoading = true;

        const [res, err] = await bdjs.goAsync(
            bdapi.post("public/submit-matchmaking", {
                name: String($name.val()).trim(),
                email: String($email.val()).trim(),
            }),
        );

        isLoading = false;
        const restData = res?.data || {};

        $(".is-not-invitation").fadeIn();

        if (restData?.success) {
            const msg = restData?.data?.message;
            $snackBar.addClass("is-active").find(".snackbar__body").html(msg);

            $name.prop("disabled", true);
            $email.prop("disabled", true);

            $btn.removeClass("is-loading").prop("disabled", true);
        }

        if (!restData.success || err) {
            const errMsg =
                restData?.data?.message ||
                "Something went wrong. Please try again!";

            $btn.removeClass("is-loading").prop("disabled", false);
            $snackBar
                .addClass("is-active")
                .find(".snackbar__body")
                .html(errMsg);
        }
    };

    const openForm = function (e) {
        $(".welcome__backhome").hide();
        const isAuth = CONFIG.isAuth;
        const playerEmail = CONFIG.user.email;
        const isMatchmaking = $(e.currentTarget).hasClass("is-matchmaking");
        const $description = $(".welcome__description");
        const $btnSubmit = $(".js-submit-btn");

        const isGeneratedEmail = (email) => {
            if (!email) return true;

            const emailArr = email.split("@");
            const domain = emailArr[1];
            const isGenerated = domain === "escaperoom.game";

            return isGenerated;
        };
        const isGenedEmail = isGeneratedEmail(playerEmail);

        if (!isAuth || isGenedEmail) {
            $(".welcome").addClass("is-login");

            if (isMatchmaking) {
                $description.addClass("is-matchmaking");
                $btnSubmit
                    .attr("id", "sendMatchmaking")
                    .attr("type", "submit")
                    .addClass("is-matchmaking");
            }

            toggleSubmitBtn(true);
        } else {
            if (isMatchmaking) {
                submitMatchMaking(e);
            } else {
                goToAddMember();
            }
        }
    };

    const toggleSubmitBtn = function (isLoginInput) {
        let isAllFilled = true;
        let $inputs = $(".invitations__fields:not(.to-be-cloned)").find(
            "input",
        );

        if (isLoginInput) $inputs = $(".welcome__form").find("input");

        $.each($inputs, function (i, input) {
            const value = String($(input).val()).trim();

            if (value == "") {
                isAllFilled = false;
                return false;
            }
        });

        $(".js-submit-btn").prop("disabled", !isAllFilled);
    };

    const goToAddMember = function () {
        $(".welcome").addClass("is-login");
        $(".welcome__steps").hide();
        $(".feedback-widget").show();
    };

    const addMember = function () {
        const $clonedItem = $(".invitations__fields.to-be-cloned");
        const totalRow = $(".invitations__fields:not(.to-be-cloned)").length;
        const maxPlayer = Number($(".max-players").text());

        if (totalRow == maxPlayer) return false;

        const newRow = $clonedItem.clone();
        newRow.attr("class", "invitations__fields").removeAttr("style");

        $(".invitations__form-inner").append(newRow);
        toggleSubmitBtn(false);
    };

    const removeField = function (e) {
        const $removeBtn = $(e.currentTarget);
        const $parent = $removeBtn.parent();

        $parent.remove();
    };

    const onInputField = function (e) {
        const isLoginInput = $(e.currentTarget).hasClass("js-login");

        toggleSubmitBtn(isLoginInput);
        $snackBar.removeClass("is-active");
    };

    const $snackBar = $(".snackbar");

    // Snackbar Component
    // ------------------------------------------------------------------------
    $snackBar.find(".snackbar__close").on("click", function (e) {
        e.preventDefault();
        $snackBar.removeClass("is-active");
    });

    init();
};
